import 'owl.carousel';

jQuery( document ).ready(function($) {
    $('.partner-wrap').owlCarousel({
        autoplay: true,
        slideTransition: 'linear',
        autoplaySpeed: 4000,
        autoplayTimeout: 4000,
        loop:true,
        items: 2,
        stagePadding: 300,
        dots: false,
        nav: false,
        margin: 30,
        responsive:{
            0:{
                items: 1,
                stagePadding: 30,
            },
            700:{
                items: 3, 
                stagePadding: 100,
            },
            1100:{
                items: 4,
                stagePadding: 100,
            },
            1400:{
                items: 4,
                stagePadding: 300,
            }
        }
    });

    $('.newsletter').on('submit', function(e) {
        e.preventDefault();
        const DATA = $(this).serialize();
    
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            dataType: 'json',
            data: DATA,
            xhrFields: {
                withCredentials: false,
            },
            success: function (data) {
                $('.inputs-wrap').html('<p class="newsletter-thanks">Thanks for signing up!</p>');
            },
            error: function (err) {
                console.log(err);
            }
        });
    });
    var siteURL = '';
    if (location.href.startsWith('https://projects')){
        siteURL="https://projects.45press.com/aglive/";
    } else {
        siteURL="https://alleslive.tickets";
    }
    
    $('.mobile-toggle a').on('click', function(e){
        e.preventDefault();
        $('#menu-nav').toggleClass('open');
    });

    $('.nav a').on('click', function(e) {
        let TARGET = $(this).attr('href');
        if (TARGET.startsWith('#')){
            e.preventDefault();
            if ($('body').hasClass('page-template-homepage')){   
                $('body, html').animate({
                    scrollTop: $(TARGET).offset().top - 100
                });
                
                $('.nav').removeClass('open');
            } else{
                location.href=siteURL + TARGET;
            }
        }
    });
});